import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'underscoreToSpace',
  standalone: false,
})
export class UnderscoreToSpacePipe implements PipeTransform {
  transform(value: string): string {
    if (value && typeof value === 'string') {
      return value.replace(/_/g, ' ');
    }
    return value;
  }
}
